export const ServicesSection = {
  heading: "Warrgyizmorsch Content Writing Services",
  description: "",
  services: [
    {
      name: "SEO Keyword Research",
      // logo: "assets/img/logo/seo_content_writing.png",
      content:
        "We perform in depth keyword research to determine the best keywords for your content. These keywords have the result of an SEO writing agency of putting your content at the top of search engine results and reaching the audience you want, which in turn brings in more organic traffic to your site.",
    },
    {
      name: "Link Building",
      // logo: "assets/img/logo/socialmedia_content_writing.png",
      content:
        "Our link building strategies increase your site’s authority and in turn its SEO rank by getting backlinks from relevant high quality sources. Backlinks tell search engines that we have quality content which in turn improves your site’s visibility.",
    },
    {
      name: "Conversion Rate Optimisation",
      // logo: "assets/img/logo/emailmarketing_content_writing.png",
      content:
        "We produce content for the purpose of conversion. We do research and write up material that leads our audience towards the desired action which may be filling out a contact form, making a purchase, or subscribing to a newsletter.",
    },
    {
      name: "Web Design and Development",
      // logo: "assets/img/logo/ecommerce_content.png",
      content:
        "Our content writing is incorporated into our web design and development. We see to it that your content goes SEO website writing with your site’s design which in turn improves the user experience and increases engagement.",
    },
    {
      name: "Search Engine Optimisation",
      // logo: "assets/img/logo/copywriting.png",
      content:
        "We do indeed create SEO friendly content and also put in the work to improve your site’s search engine rankings. We use our SEO strategies to make sure your content is what people are looking for and that it reaches your target audience.",
    },
    {
      name: "Content Development Strategy",
      // logo: "assets/img/logo/blogwriting.png",
      content:
        "Our content we have put together as a strategy which is centred on what will best achieve your SEO copywriting agency business goals. We have put together content calendars, topics and formats which we have researched to do what your audience wants and which also produce consistent results.",
    },
    {
      name: "eCommerce Marketing",
      // logo: "assets/img/logo/ebookwriting.png",
      content:
        "For online stores we craft product descriptions, blog posts, and SEO content which in turn increases visibility, drives traffic, and turns visitors into buyers. Also we work to improve your site’s performance in search engines.",
    },
    {
      name: "Social Media Marketing",
      // logo: "assets/img/logo/content_optimization.png",
      content:
        "We develop content that is perfect for social media which in turn gets your brand in front of its audience. Our team works to put together posts that engage users, build relationships, and to increase your online presence.",
    },
    {
      name: "Pay-Per-Click",
      // logo: "assets/img/logo/ebookwriting.png",
      content:
        "Our content is an addition to your PPC efforts. We craft persuasive ad copy and optimized landing pages which in turn improves the performance of your paid search campaigns which we see in better click through and conversion rates.",
    },
    {
      name: "Email Marketing",
      // logo: "assets/img/logo/content_optimization.png",
      content:
        "We create email content that produces action. Whether it’s a newsletter, promotional email, or product announcement we see to it that your message connects with the recipient and prompts them to act.",
    },
  ],
};

const placeholderSVG = (color) => `
    <svg width="24" height="24" fill="${color}" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="10" fill="${color}" />
      <path d="M8 12l2 2 4-4" stroke="#fff" stroke-width="2" fill="none" />
    </svg>
  `;

export const LargeData = {
  heading: "Content Marketing Enhanced by SEO Research",
  description: "",
  services: [
    {
      title: "Research and Planning",
      svg: placeholderSVG("#18336c"),
      content:
        "Research is key to developing great SEO writing. We begin by which keywords to use, what the search intent is behind those keywords, and we do research on your target audience. This step allows us to determine the best topics as well as find out which factors will get you to rank higher in search engines.",
    },
    {
      title: "Approval",
      svg: placeholderSVG("#2f5597"),
      content:
        "Once we finish our research and planning phase we present the strategy to you for your approval. This gives you a chance to review the content direction and put in any changes before we move on. We value your feedback in that it is key to which the content also as an extension your brand values and business goals do in fact match up.",
    },
    {
      title: "Creation of Content Briefs",
      svg: placeholderSVG("#006778"),
      content:
        "We have SEO content services created content briefs which guide the content creation process. In them we include key elements like target keywords, tone of voice, content structure and style which in turn ensures consistency across all pieces. Also we use these briefs to improve communication between our team and you which in turn reduces the number of revisions and we align with your vision.",
    },
    {
      title: "Upload",
      svg: placeholderSVG("#8a3ffc"),
      content:
        "Once your content is ready we go ahead and upload it to your website. At this stage we pay close attention to formatting and also we integrate SEO elements into the content. This includes the use of meta-tags, image alt text, internal and external links and other on page SEO features. We are very careful in the upload process which in turn causes your content to rank better and in turn attract more visitors. Our attention to detail causes your content to perform better.",
    },
    {
      title: "Proofing",
      svg: placeholderSVG("#ff7a59"),
      content:
        "Proof at the proofreading stage is key to content quality and clarity. We go over the material for grammar issues, punctuation errors, and the overall flow to provide you with an excellent reading experience. Also we see to it that the content is on brand in terms of voice and message. Proofing also includes checking facts and data accuracy which is very important for the content’s credibility.",
    },
    {
      title: "Content Writing",
      svg: placeholderSVG("#42be65"),
      content:
        "Our team of content writers creates engaging, SEO content writing service, blogs, and web pages. We put out high quality content which we research to answer what our audience is searching for and at the same time we put in relevant keywords and SEO tactics. We design each SEO website content writer piece to grab the audience’s attention, keep them there, and to give them what they are looking for.",
    },
    {
      title: "Client Feedback & Revisions",
      svg: placeholderSVG("#1192e8"),
      content:
        "Upon creation of the content we will send it over to you for your input. This is a very important step in the process which is in place to make sure we are on target with what you are looking for. We look forward to working with you through the revision process which we believe is key in getting the final piece to reflect your vision, tone and messaging.",
    },
    {
      title: "Ongoing Support & Updates",
      svg: placeholderSVG("#fa4d56"),
      content:
        "Once the content is out there we provide continuous support and updates in order to keep it relevant. We look at the performance of the content, which includes the traffic it generates and the SEO copywriting engagement from users. Should it be the case that we see fit, we will update the post with new info, trends, or keywords which in turn will keep the content fresh and performance at high levels.",
    },
  ],
};

export const CustomSection = {
  heading: "The Importance of SEO Content Writing for Business Growth",
  description: `Content marketing is of major importance in keeping the brand in the public eye, engaging the audience, and long-term growth, and this makes it possible to set your business apart from the rest, earn trust, and attract quality leads. Through the strategic use of content, we are able to create value for content optimization for the audience while converting interest into action-the primary drivers of brand visibility, credibility, and ultimately success.`,
  services: [
    {
      name: "Build Brand Awareness",
      //   logo: "assets/img/logo/php_logo.png",
      content:
        "SEO content writing is a key for your business to target new audiences as it increases the brand's online presence. By producing fine-tuned content that informs, trains, and puts forward your point of view you also present your brand as the authority in your field. As people look at your content first they are reinforcing your status as a top name in your field.",
    },
    {
      name: "Attracts Organic Traffic",
      //   logo: "assets/img/logo/laravel_logo.png",
      content:
        "Optimized content which in turn attracts large audiences to your site at no extra cost of pay per click ads. We put into play search engine based strategies which in turn see your content rank higher, which in turn brings in organic traffic that is more likely to turn into leads or sales. This type of traffic is sustainable, cost effective, and in the long term more reliable.",
    },
    {
      name: "Grow Your Online Authority",
      //   logo: "assets/img/logo/cakephp_logo.png",
      content:
        "SEO content puts your business at the front of your field. By putting out high quality, in depth content on a regular basis you inform your audience and also improve your search engine authority. This credibility we bring to the table can result in higher rankings for your business and also more trust from your potential customers.",
    },
    {
      name: "Get Better SEO Results",
      //   logo: "assets/img/logo/node_logo.png",
      content:
        "By integrating your content with SEO tactics like the use of relevant keywords and internal linking your site performance on search engines will see an increase. We see this as a boost to your site’s total SEO which in turn raises search rank and we also see that it increases the traffic which is more targeted and thus more likely to become a customer.",
    },
    {
      name: "Earn Long-Term Revenue",
      //   logo: "assets/img/logo/mean_logo.png",
      content:
        "Quality SEO content is a growth investment which pays off over time. As your content attracts more in coming visitors and does better on search engines it will see your revenues grow. Also evergreen content will continue to bring in traffic post publication which in turn gives you long term financial benefits.",
    },
    {
      name: "Supports Conversion Optimization",
      //   logo: "assets/img/logo/codeignitor_logo.png",
      content:
        "Good content is what draws in visitors but also what convinces them to act. With strategic calls to action and what is basically persuasive writing we see content which guides visitors through the website content writing service sales process. Well written and optimized content which in turn seems to increase conversion rates by00 it makes the decision process easier for prospective customers.",
    },
  ],
};

export const BenefitSection = {
  heading: "Why Warrgyizmorsch Is Your Best Choice for SEO Content Marketing",
  description: "",
  services: [
    {
      name: "Professional SEO Content Writers",
      //   logo: "https://cdn-icons-png.flaticon.com/512/1170/1170576.png",
      content:
        "At Warrgyizmorsch we are known for our expert team of content writers which we have dedicated to SEO. Our writers are not only talented in putting out engaging and informative content but also have in-depth knowledge of the SEO field. They are well versed in the play of keywords, they craft content which is search engine friendly and produce quality articles that do well in search results.",
    },
    {
      name: "High-Quality, Engaging Content",
      //   logo: "https://cdn-icons-png.flaticon.com/512/942/942748.png",
      content:
        "We have that great quality content is the base of any successful content marketing strategy. We create content which not only informs but which also engages, entertains, and also puts forth to action. In that we look at your target audience and what they need, we create content for them, which addresses their issues and which puts out valuable solutions.",
    },
    {
      name: "Long-Term SEO Success",
      //   logo: "https://cdn-icons-png.flaticon.com/512/1828/1828961.png",
      content:
        "SEO is a marathon not a sprint which is what we at Warrgyizmorsch live by. We put our effort into developing strategies that will take you to the top in the long run instead of what will drop us in first place for the moment. From content optimization to improving site architecture we use what works best to put your search engine ranking up, get you that steady flow of traffic, and in the end see more sales.",
    },
    {
      name: "Client-Centric Approach",
      //   logo: "https://cdn-icons-png.flaticon.com/512/889/889118.png",
      content:
        "Our focus is on you the client which is what sets us apart from other SEO content companies. We see that each business has its own set of goals, challenges, and audiences which is why we tailor our content plans to what you need. If you are looking to raise brand awareness, bring in more traffic, or turn leads into customers we work closely with you to develop a content strategy that will achieve your goals.",
    },
  ],
};


export const AssistanceSection = {
  heading: "What Are the Benefits of Content Writing?",
  content: `Content creation is a key element of a robust online presence. By putting out high quality, SEO optimized content on a regular basis you can grow trust with your audience. Also we see that content creation increases organic traffic to the site which in turn makes it a more visible result on search engines.`,
};

export const FAQ = [
  {
    header: "SEO Content Writing",
    question: "How Do You Write SEO Content?",
    answer:
      "SEO content is a mix of articles, blogs, and web pages which we craft to be search engine friendly at the same time as reader engaging. We do in depth keyword research, pay attention to on page SEO elements, and produce what our target audience is looking for. By the use of SEO tactics in conjunction with great writing we see to it that your content does well in search results and at the same time is of great value.",
  },
  {
    header: "Web Development",
    question: "Do SEOs Write Content?",
    answer:
      "Yes, we see that SEO professionals get involved in content creation. While they primarily focus on search engine optimization we also note that quality of content is an important aspect which they take care of. SEO’s work in a very close fashion with content creators which helps implement SEO best practices into each piece, making it not only engaging for the audience but also performing well in search results.",
  },
  {
    header: "Web Development",
    question: "What Different Types of Content Writing Do You Offer?",
    answer:
      "We provide a wide range of content writing services which include blog posts, product descriptions, landing pages, articles, and social media content. We tailor each piece to achieve your business goals and also see to it that it connects with your target audience and is search engine friendly.",
  },
  {
    header: "Web Development",
    question: "How Important Are Keywords in Content Writing?",
    answer:
      "Keywords are a key element in content writing as they get search engines to understand what your content is about in relation to certain search terms. We put in the proper keywords into your content which in turn gets you rank for the right topics which in turn increases visibility and brings in organic traffic.",
  },
  {
    header: "Web Development",
    question: "How Much Do SEO Content Writing Services Cost?",
    answer:
      "SEO content writing services’ cost which is based on that of the content’s length, degree of complexity and frequency of publication is what you should expect. As a general note, we see charges that range between $100 to $500 for a single blog post or page.",
  },
  {
    header: "Web Development",
    question: "How much should I pay someone for SEO?",
    answer:
      "SEO services’ cost varies based on the scale of the project, which of the websites is complex and the degree of expertise required. As a rule of thumb businesses pay between $500 to $5,000 per month for full service SEO which includes content creation, link building and technical optimization. Also tailored made SEO packages tend to be a better value.",
  },
  {
    header: "Web Development",
    question: "How Much Do SEO Writers Charge?",
    answer:
      "SEO writers can charge in a range of 150 per hour that is based on their experience and the project’s level of complexity. Also some may base their rate per article or per word which will be between $0.10 to $1 per word. While rates may vary, it is important to look at the writer’s expertise and the quality of the content they produce.",
  },
];
